import { ModalBody } from '@components-deprecated'

import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const GridContainer = styled.div`
  display: grid;
  column-gap: ${Spacing.S16};
  grid-template-columns: 1fr 1fr;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: ${Spacing.S32};
  padding-bottom: ${Spacing.S12};
`

export const EmptyCell = styled.div``

export const FormSection = styled.section`
  & + & {
    margin-top: ${Spacing.S32};
    padding-top: ${Spacing.S32};
    border-top: 1px solid ${Color.Grey150};
  }
`

export const ModalBodyScrollable = styled(ModalBody)`
  overflow: auto;
`
